module.exports = __webpack_public_path__ + "img/lg_ring_y_skip_null_null@2x.f5b08132.png";